import Cache from 'root/cache';
import View from 'view/base';
import Modals from 'root/modals';

var Expired_Account = View.extend({
    className: 'expired-account-dialog',

    events: {
        'click .upgrade': 'upgrade'
    },

    dom_handlers: {
        upgrade: function(e) {
            e.preventDefault();

            Modals.choosePlan();
        }
    },

    initialize: function(options) {
        this.is_free = !!options.is_free;
    },

    render: function() {
        var content =
        '<div class="desc">' +
            '<div class="margin-bottom-32">' +
                (this.is_free ?

                '<h1><b>Feedback Availability Reached</b></h1>' +
                '<p class="text-medium-large line-height-150">On the free plan, feedback is available for 7 days.<br>Unlock feedback by upgrading to a paid plan.</p>'

                :

                (Cache.account.isPricing2025() ?

                '<h1><b>Your Business Plus trial has ended</b></h1>' +
                '<p class="text-medium-large line-height-150">You\'ve been moved to our Free Plan. Upgrade anytime to unlock premium features and get the most out of Userback.</p>'

                :

                '<h1><b>Your trial has ended</b></h1>' +
                '<p class="text-medium-large line-height-150"><a class="upgrade primary font-weight-medium" href="#">Upgrade now</a> and plug back in to your customer feedback.</p>')
                ) +
            '</div>' +
            '<div class="margin-top-32"><button class="upgrade shiny large"><span>Upgrade now</span></button></div>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});

export default Expired_Account;